// extracted by mini-css-extract-plugin
export default {"main":"_87ad275cd9 e9048a5ab4","xmark":"_6c07388f71","fl_img":"c0e35feaa5 _317755febc"};